import { Col, Row, Typography } from "antd";
import React, { FC } from "react";

interface IDataItems {
  data: { heading: string; content: string | number | React.ReactNode }[];
}
const DataItems: FC<IDataItems> = ({ data }) => (
  <Row gutter={[0, 8]}>
    {data.map(({ content, heading }) => (
      <>
        <Col span={8}>
          <Typography.Text type="secondary">{heading}</Typography.Text>
        </Col>
        <Col span={16}>{typeof content === "string" ? <Typography.Text>{content}</Typography.Text> : content}</Col>
      </>
    ))}
  </Row>
);

export default DataItems;
